import { useTranslation } from 'react-i18next';

import { Box, Button } from '@myphx-engineering/phx-design-system';

type MedicationOrderStateDisplayProps = {
    isUnclaimed: boolean;
    verifyOrder: () => void;
    fillOrder: () => void;
};

export const MedicationOrderStateDisplay = ({
    isUnclaimed,
    verifyOrder,
    fillOrder,
}: MedicationOrderStateDisplayProps) => {
    const { t } = useTranslation();

    if (isUnclaimed) {
        return (
            <Box>
                <Button
                    variant="outline"
                    onClick={verifyOrder}
                    size="sm"
                    data-testid="medication-entry-verify-button"
                >
                    {t('cabinet.orders.verify')}
                </Button>
            </Box>
        );
    }

    return (
        <Box>
            <Button
                variant="contained"
                onClick={fillOrder}
                size="sm"
                data-testid="medication-entry-fill-button"
            >
                {t('cabinet.orders.fill')}
            </Button>
        </Box>
    );
};
